module.exports = __webpack_public_path__ + "img/IMG_0374_L_Wood_MockedUp.3d1e578e.jpg";